export default {
  namespaced: true,
  state: {
    auctionSaleId: '',
    roundId: '',
    matchId: '',
    auctionObj: {
      activityName: '',
      auctionSaleId: '',
      roundId: '',
      matchId: '',
      articleId: ''
    }
  },
  getters: {
    auctionSaleId(state) {
      return state.auctionSaleId || ''
    },
    matchId(state) {
      return state.matchId || ''
    },
    roundId(state) {
      return state.roundId || ''
    },
    auctionObj(state) {
      return state.auctionObj || ''
    }
  },
  mutations: {
    SET_AUCTION_ID: (state, auctionSaleId) => {
      state.auctionSaleId = auctionSaleId
    },
    SET_AUCTION_ROUNDID: (state, roundId) => {
      state.roundId = roundId
    },
    SET_AUCTION_MATCHID: (state, matchId) => {
      state.matchId = matchId
    },
    SET_AUCTION_AUCTIONOBJ: (state, auctionObj) => {
      state.auctionObj = auctionObj
      state.auctionSaleId = auctionObj.auctionSaleId || ''
      state.roundId = auctionObj.roundId || ''
      state.matchId = auctionObj.matchId || ''
    }
  }
}
